<template>
  <div class="popAdvertisement" v-if="isPop">
    <div class="popAdvertisement-box">
      <img class="img" :src="datas.pic" @click="toLink">
      <div class="close" @click="closeLayer"><i class="iconshanchu1 iconfont"></i></div>
    </div>
  </div>
</template>
<script>
import { jAlert3, jAlert5 } from '@/base/jAlert/jAlert';
import { getStorage } from '@/utils/wxuser';
export default {
  data() {
    return {
        isPop:true
    }
  },
  props: {
    datas: Object
  },
  methods: {
    toLink() {
      if (this.datas.link != '') {
        window.location.href = this.datas.link
      }
    },
    closeLayer(){
        this.isPop = false
    }
  },
  mounted() {

  },
}
</script>
<style lang="less" scoped>
.popAdvertisement {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  .popAdvertisement-box{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 80vw;
  }
  .img {
    width: 80vw;
  }
  .close {
    display: flex;
    justify-content: center;

    i {
      margin-top: 0.4rem;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      font-size: 30px;
      color: #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/polymerization/popAdvertisement.vue